function Project(){
    return(
        <>
            <section className="" id="projects">
                <div className="bg-dark mb-5">
                    <div className="container pt-5 pb-4 w-75">
                        <div className="row">
                            <div className="col-md-6">
                                <h2 className="primary-text">Have an project to discuss ?</h2>
                                <p className="info-text">Let's collaborate today and bring your vision to life.</p>
                            </div>
                            <div className="col-md-6">
                                <button className="dd-strong float-end p-1 mt-2">Get in Touch</button>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div className="mt-5 container w-75">
                    <div className="row">
                        <p className="info-text col-md-6">MY PROJECTS</p>
                        <div className="col-md-6">
                            <a className="dd-info p-1 float-end fw-bold text-decoration-none" href="https://github.com/DineshKumar2025-dev?tab=repositories" target="_blank" rel="noreferrer">All Projects</a>
                        </div>                        
                    </div>                    
                </div>
                <div className="all-projects mt-5 container">
                    <div className="row">
                        <div className="col-md-6 project">
                            <span className="dd-strong-text">web development | AI</span>
                            <h2 className="primary-text mt-2">AI CAR PARKING SYSTEM</h2>
                            <p className="info-text">
                                I developed a real-time smart car parking monitoring system using Python, OpenCV (cv2), NumPy, HTML, and CSS. The system analyzes live video feeds to detect parking slot occupancy using image processing techniques such as grayscale conversion, thresholding, and contour detection. NumPy was used for efficient frame processing, while a responsive web interface dynamically displays parking availability. The solution was optimized to ensure reliable performance in real-world conditions.
                            </p>
                            <a href="https://github.com/DineshKumar2025-dev/Ai-Car-parking/tree/main/car%20parking" target="_blank" rel="noreferrer" className="text-decoration-none">
                                <div className="flex items-center justify-start mb-4 -ml-1">
                                    <img src="Attachments/images/link_icon.svg" alt="ink"></img>
                                    <span className="font-rubik font-semibold text-base tracking-wide text-white -ml-1">GitHub Repo</span>
                                </div>
                            </a>
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">PYTHON</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">NUMPY</span>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">CV-3</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">HTML</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            <div className="img-wrapper text-center">
                                <img 
                                    src="Attachments/images/project-1.png" 
                                    className="project-img img-fluid" 
                                    alt="project"
                                />
                            </div>                            
                        </div>
                    </div>
                    <div className="row flex-row-reverse ">
                        <div className="col-md-6 project">
                            <span className="dd-strong-text">web development</span>
                            <h2 className="primary-text mt-2">MOM Food <br></br>FOOD DELIVERY APP</h2>
                            <p className="info-text">
                                I developed a food delivery application called Mom-Food, designed to connect customers with home chefs who prepare fresh, homemade meals. The platform focuses on delivering healthy, hygienic, and affordable home-cooked food directly from kitchens to customers’ doorsteps. I built the backend using CFML (ColdFusion Markup Language) and managed the database with pgAdmin (PostgreSQL). The application includes secure authentication mechanisms, encrypted data handling, and proper session management to ensure user data protection. It supports features such as user registration, menu management, order placement, payment processing, and real-time order tracking. The system ensures smooth coordination between home cooks and customers while maintaining strong security protocols and efficient database management.
                            </p>
                            <a href="https://github.com/DineshKumar2025-dev/mom-food/tree/main" target="_blank" rel="noreferrer" className="text-decoration-none">
                                <div className="flex items-center justify-start mb-4 -ml-1">
                                    <img src="Attachments/images/link_icon.svg" alt="ink"></img>
                                    <span className="font-rubik font-semibold text-base tracking-wide text-white -ml-1">GitHub Repo</span>
                                </div>
                            </a>
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">CFML</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">jQuery</span>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">PostgreSQL</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">BS-5</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            <div className="img-wrapper text-center">
                                <img 
                                    src="Attachments/images/project-2.png" 
                                    className="project-img img-fluid" 
                                    alt="project"
                                />
                            </div>                            
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 project">
                            <span className="dd-strong-text">web development | PHP</span>
                            <h2 className="primary-text mt-2">SR INTERIORS<br></br>INTERIOR DESIGN APPLICATION</h2>
                            <p className="info-text">
                               SR Interiors is an interior design service website developed using PHP and MySQL. The platform is designed to provide a seamless and hassle-free experience between clients and interior designers. It allows customers to explore services, submit project requirements, and communicate directly with designers through a structured system. The backend is built with PHP for efficient server-side processing, while MySQL is used for secure data storage and management. The website ensures smooth project tracking, service inquiries, and appointment scheduling, creating a streamlined workflow that simplifies coordination between clients and designers.
                            </p>
                            <a href="https://github.com/AbhiramNalla/SR_Interiors" target="_blank" rel="noreferrer" className="text-decoration-none">
                                <div className="flex items-center justify-start mb-4 -ml-1">
                                    <img src="Attachments/images/link_icon.svg" alt="ink"></img>
                                    <span className="font-rubik font-semibold text-base tracking-wide text-white -ml-1">GitHub Repo</span>
                                </div>
                            </a>
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">PHP</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">Java Script</span>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">My SQL</span>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="">
                                            <img src="Attachments/images/checkmark-1.svg" alt="check" className="check"></img>
                                        </div>
                                        <span className="font-rubik text-base tracking-wider text-white">XAMPP</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            <div className="img-wrapper text-center">
                                <img 
                                    src="Attachments/images/project-3.png" 
                                    className="project-img img-fluid" 
                                    alt="project"
                                />
                            </div>                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Project;